// src/lib/local-tick.js -- #1554 (Ultron G3).
// Single job: hand out a strictly increasing number on every call, so two client-side events in
// one app process can be ordered against each other ("was this bet added before or after that
// cloud load started?"). Not a clock: it never goes backwards and means nothing across processes.
let tick = 0;

export function nextLocalTick() {
  tick += 1;
  return tick;
}
